import { useAuthClient } from '@gef-ui/authorization-v2';
import { useConfig } from '@gef-ui/env-config';
const useSendErrorBase = (sendErrorCallback)=>{
    const config = useConfig();
    const authClient = useAuthClient();
    const sendError = async (body)=>{
        const token = await authClient.getAccessToken();
        return fetch(`${config.apiUrl}/helpdesk`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*',
                ...body.representativeFor ? {
                    'Representative-for': body.representativeFor
                } : {}
            },
            body: JSON.stringify(body)
        });
    };
    return sendErrorCallback ?? sendError;
};
export default useSendErrorBase;
